module.exports = __webpack_public_path__ + "img/base.14cd9b85.png";